<template>
  <div>
    <data-table
      :table-data="data"
      :page.sync="data.page"
      :pageSize.sync="data.pageSize"
      :columns="columns"
      :is-pagination-show="isPaginationShow"
    />
  </div>
</template>

<script>
  import DataTable from '../../components/DataTable'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN";

  export default {
    name: "FinancingListDataTable",
    data(){
      return {

      }
    },
    computed: {
      data: {
        get() {
          return this.value
        },
        set(newVal) {
          this.$emit('input', newVal)
        }
      }
    },
    props: {
      value: {
        type: Object,
        default: () => {
          return {
            data: [],
            count: 0
          }
        }
      },
      columns: {
        type: Array,
        default: ()=>{
          return [
            {
              name: '贷款编号',
              field: 'fi__transactionNo'
            },
            {
              name: '客户名称',
              field: 'u__customerName'
            },
            {
              name: '贷款用途',
              field: 'fi__intendedUse'
            },
            {
              name: '贷款金额',
              field: 'fi__totalAmount',
            },
            {
              name: '开始日',
              field: 'fi__startDate',
              formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD')
              }
            },
            {
              name: '到期日',
              field: 'fi__endDate',
              formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD')
              }
            },
            {
              name: '贷款状态',
              field: 'fi__transactionStatus',
              formatter: function (r,c,v) {
                return Status2CN(v)
              }
            }
          ]
        }
      },
      isPaginationShow: {
        type:Boolean,
        default: true
      }
    },
    components: {
      DataTable
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/FinancingListDataTable.vue